import { mediaItems } from '@/mocks/homeData';

export default function Media() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">爆料视频</h2>
            <p className="mt-2 text-sm text-foreground-500">热门吃瓜视频，深度解析网红黑料真相</p>
          </div>
          <a
            href="#"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            更多视频 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200/50 overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-44 md:h-48 object-cover transition-transform duration-500 group-hover:scale-105"
                  width="600"
                  height="340"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 text-xs bg-black/70 text-white px-2 py-0.5 rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>

              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i> {item.views}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}